import Units from "../../../utils/Units";

let gridColor = "rgba(0, 0, 0, 0.1)";
let tickFontSize = 10;
let Percentage = {
    id: "percentage",
    gridLines: {
        color: gridColor,
        zeroLineColor: "rgba(0, 0, 0, 0)"
    },
    ticks: {
        fontSize: tickFontSize,
        maxTicksLimit: 10,

        callback: (value, index, values) => {
            return Math.round(value,2) + " %";
        }
    }
};

export default Percentage;


// WEBPACK FOOTER //
// ./src/components/chart/axes/Percentage.js